// extracted by mini-css-extract-plugin
module.exports = {"root":"CollapsibleCol_root__iuut8","smooth":"CollapsibleCol_smooth__VMDCe","collapsed":"CollapsibleCol_collapsed__sKjZP"};